module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "centerf"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TABLE OF")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/common.jpg",
      "width": "81"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chap-c",
    attrs: {
      "id": "contents"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/intro#intro"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/line1.jpg",
      "width": "400"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01#part01"
    }
  }, [_c('em', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("PART ONE")])]), _c('br'), _vm._v("THE HISTORY OF OUR TASTE FOR MAPLE SYRUP")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02#part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("PART TWO")])]), _c('br'), _vm._v("THE SCIENCE OF GROWING, TAPPING, AND EVAPORATING SAP INTO SYRUP")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03#part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("PART THREE")])]), _c('br'), _vm._v("COOKING WITH MAPLE SYRUP")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/line1.jpg",
      "width": "400"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ack#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/author#author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE AUTHOR")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/works#works",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WORKS CONSULTED")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX OF SEARCHABLE TERMS")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0